import React, { Component } from 'react';
import axios from 'axios';
import { API_HOST } from '../../consts';
import DreReportColumn from '../../components/DreReportColumn';
import { withTheme } from 'styled-components';

class ReportDrePage extends Component {
  state = {
    loading: false,
    boletimData: {}
  };

  componentDidMount() {
    this.setDr()
    this.fetchTableData();
    this.fetchTableRedeData();
  }
  componentWillUnmount() {
    this.state.loading = true;
  }
  setDr = () => {
    if (this.props.match.params.drId) {
      this.setState({ drId: this.props.match.params.drId })
    } else {
      this.setState({ drId: false })
    }
  }
  fetchTableData = () => {
    const cd_disciplina = this.props.match.params.cd_disciplina;
    const params = {
      cd_periodo: this.props.match.params.periodoId,
    }
    axios
      .get(`${API_HOST}/avalia/presenca_dre/${cd_disciplina}/get_presenca_dre`, { params })
      .then((res) => {
        this.setState({ presencaDreData: res.data.dre })
      })
      .catch((err) => console.error(err));
  };
  fetchTableRedeData = () => {
    const periodoId = this.props.match.params.periodoId;
    const cd_disciplina = this.props.match.params.cd_disciplina;
    axios
      .get(
        `${API_HOST}/avalia/presenca_rede/${cd_disciplina}/get_presenca_rede?cd_periodo=${periodoId}`
      )
      .then((res) => {
        this.setState({ presencaRedeData: res.data.rede });
      })
      .catch((err) => console.error(err));
  };

  render() {
    const { presencaDreData, presencaRedeData, loading, drId } = this.state;

    return (
      <>
        <div style={{ marginTop: '3rem', background: '#fff' }}>
          <div className="container mb-4 pb-4">
            <div className="row">
              <div className="col-12">
                <div
                  className="card"
                  style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                >
                  <div
                    className="card-header"
                    style={{
                      marginBottom: '-0.7rem',
                      backgroundColor: '#f7f7f7',
                      borderRadius: '10px'
                    }}
                  >
                    <h1
                      style={{
                        fontFamily: 'Quicksand',
                        fontSize: '24px',
                        color: '#292929',
                        fontWeight: 'bold'
                      }}
                    >
                      Relatórios de Presença dos Estudantes
                    </h1>

                    <hr
                      style={{
                        background: '#bebebe',
                        width: '100%',
                        height: '1px',
                        borderRadius: '1px'
                      }}
                    />
                  </div>

                  <div
                    style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column'
                    }}
                  >
                    <div
                      style={{
                        marginTop: '1.5rem',
                        width: '97%',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: this.props.theme.primary,
                        fontFamily: 'Quicksand'
                      }}
                    >
                      Rede | Relatório de Participação dos Estudantes
                    </div>
                    <hr
                      style={{
                        background: '#bebebe',
                        width: '97%',
                        height: '1px',
                        borderRadius: '1px',
                        marginBottom: '1rem'
                      }}
                    />
                    <DreReportColumn tipo={'rede'} data={presencaRedeData} ano={this.props.match.params.periodoId} />
                    <div
                      style={{
                        marginTop: '3rem',
                        width: '97%',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        color: this.props.theme.primary,
                        fontFamily: 'Quicksand'
                      }}
                    >
                      REDE | Relatório de Participação dos Estudantes
                    </div>
                    <hr
                      style={{
                        background: '#bebebe',
                        width: '97%',
                        height: '1px',
                        borderRadius: '1px',
                        marginBottom: '1rem'
                      }}
                    />
                    <DreReportColumn tipo={'dre'} drId={drId} data={presencaDreData} ano={this.props.match.params.periodoId} />
                    <div
                      className="input-type-style"
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginLeft: '3rem'
                      }}
                    >
                      <button
                        style={{
                          marginTop: '1rem',
                          color: 'white',
                          backgroundColor: '#9c9c9c',
                          border: 'none',
                          fontSize: '1rem',
                          fontWeight: '600',
                          textAlign: 'center',
                          cursor: 'pointer',
                          borderRadius: '15px',
                          boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                          letterSpacing: '1px',
                          padding: '4px 16px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                        onClick={() => window.history.back()}
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTheme(ReportDrePage);
